import { Routes } from '@angular/router';
import { AuthGuard } from '../../auth/_guards/auth.guard';

export const regulatoryRoutes: Routes = [
  { path: 'survey/:id/:id2', loadComponent: () => import('./survey/survey.component').then(x => x.SurveyComponent), canActivate: [AuthGuard] },
];